import { useEffect } from 'react';
import { useTheme } from '@annunciate/ui';
export const useBodyStyles = () => {
    const theme = useTheme();
    useEffect(() => {
        if (theme?.colors?.backgroundPrimary) {
            window.document.body.style.backgroundColor = theme?.colors?.backgroundPrimary;
        }
    }, [
        theme?.colors?.backgroundPrimary,
    ]);
    return theme?.dark;
};
//# sourceMappingURL=useBodyStyles.js.map